export function maxBy(array:any[], key:string) {
	const max = array.reduce(
		(max, character) => (character[key] > max ? character[key] : max),
		array[0][key]
	);
	return max;
}

export function mapOrder(array:any[], order:any[], key:string) {

	if (order === undefined) {
		return array;
	}

	let nextArray:any = new Array(array.length);

	array.map((item:any, index:number) => {
		// let i:number = order.indexOf(item[key]);
		if (order.indexOf(item[key]) !== -1) {
			nextArray[order.indexOf(item[key])] = item;
		} else {
			
		}
	})

	return nextArray;
};

export function findFirstImagePath(array:any[]) {
	const result = array.find((item: any) => 
		(item.content?.content[0]?.imagePath?.length > 0 && !item.content?.content[0]?.imagePath.includes('dummy')) ||
    (item.content?.content[1]?.imagePath?.length > 0 && !item.content?.content[1]?.imagePath.includes('dummy'))
	);

  const firstColImagePath = result?.content?.content[0]?.imagePath;
  const secondColImagePath = result?.content?.content[1]?.imagePath;

  if (firstColImagePath?.length > 0 && !firstColImagePath.includes('dummy')) {
    return firstColImagePath;
  } else if (secondColImagePath?.length > 0 && !secondColImagePath.includes('dummy')) {
    return secondColImagePath;
  } else {
    return '';
  };
};